import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PerfilContainer from "./PerfilContainer";
import Introduccio from "./introduccio/Introduccio";
import Visualitzacio from "./visualitzacio/Visualitzacio";
import VisualitzacioObservadors from "./visualitzacioObservadors/VisualitzacioObservadors";
import TitolHeader from "./TitolHeader";
import IntroduccioIndividuFenofasesCarrusel from "./introduccio/IntroduccioIndividuFenofasesCarrusel";
import IntroduccioPujarFotos from "./introduccio/IntroduccioPujarFotos";
import CanviarContrasenyaFormulari from "./CanviarContrasenyaFormulari";
import Observador from "./observador/Observador";
import ObservadorDetall from "./observador/ObservadorDetall";
import ObservadorFormulariDonarAlta from "./observador/ObservadorFormulariDonarAlta";
import ObservadorFormulariDonarBaixa from "./observador/ObservadorFormulariDonarBaixa";
import ObservadorIntroduccio from "./observador/ObservadorIntroduccio";
import Indret from "./indret/Indret";
import IndretDetall from "./indret/IndretDetall";
import IndretIntroduccio from "./indret/IndretIntroduccio";
import IndretFormulariDonarBaixa from "./indret/IndretFormulariDonarBaixa";
import Individu from "./individu/Individu";
import IndividuDetall from "./individu/IndividuDetall";
import IndividuIntroduccio from "./individu/IndividuIntroduccio";
import IndividuFormulariDonarBaixa from "./individu/IndividuFormulariDonarBaixa";
import Login from "./Login";
import Peu from "./Peu";
import Menu from "./Menu";
import Accessibilitat from "./Accessibilitat";
import logoFENOCAT from "../images/logos/logo_feno_flor.png";
import styles from "./App.module.css";
import * as rutes from "../routes";

const App = () => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <Menu visible={false} />
        <div className={styles.logoFenocat}>
          <img src={logoFENOCAT} alt="Fenocat" />
          <span>Fenocat</span>
        </div>
        <TitolHeader titol="Titol Apartat" />
      </header>
      <main className={styles.main}>
        <Switch>
          <Redirect
            exact
            from={rutes.rutaArrel}
            to={rutes.rutaObservacionsIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaObservacionsIntroduccio}
            component={Introduccio}
          />

          <Route
            exact
            path={rutes.rutaObservacionsVisualitzacio}
            component={Visualitzacio}
          />

          <Route
            exact
            path={rutes.rutaObservadorsVisualitzacio}
            component={VisualitzacioObservadors}
          />

          <Route
            exact
            path={rutes.rutaObservacionsIntroduccioFenofasesIndividu}
            component={IntroduccioIndividuFenofasesCarrusel}
          />

          <Route
            exact
            path={rutes.rutaPujarFotos}
            component={IntroduccioPujarFotos}
          />

          <Route
            exact
            path={rutes.rutaCanviContrasenya}
            component={CanviarContrasenyaFormulari}
          />

          <Route exact path={rutes.rutaObservadors} component={Observador} />

          <Route
            exact
            path={rutes.rutaIntroduccioObservador}
            component={ObservadorIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaDetallObservador}
            component={ObservadorDetall}
          />

          <Route
            exact
            path={rutes.rutaEdicioObservador}
            component={ObservadorIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaAltaObservador}
            component={ObservadorFormulariDonarAlta}
          />

          <Route
            exact
            path={rutes.rutaBaixaObservador}
            component={ObservadorFormulariDonarBaixa}
          />

          <Route exact path={rutes.rutaIndrets} component={Indret} />

          <Route exact path={rutes.rutaDetallIndret} component={IndretDetall} />

          <Route
            exact
            path={rutes.rutaIntroduccioIndret}
            component={IndretIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaEdicioIndret}
            component={IndretIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaBaixaIndret}
            component={IndretFormulariDonarBaixa}
          />

          <Route exact path={rutes.rutaIndividus} component={Individu} />

          <Route
            exact
            path={rutes.rutaDetallIndividu}
            component={IndividuDetall}
          />

          <Route
            exact
            path={rutes.rutaIntroduccioIndividu}
            component={IndividuIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaEdicioIndividu}
            component={IndividuIntroduccio}
          />

          <Route
            exact
            path={rutes.rutaBaixaIndividu}
            component={IndividuFormulariDonarBaixa}
          />

          <Route
            exact
            path={rutes.rutaAccessibilitat}
            component={Accessibilitat}
          />

          <Route exact path={rutes.rutaPerfil} component={PerfilContainer} />
          <Route exact path={rutes.rutaLogin} component={Login} />
        </Switch>
      </main>
      <footer className={styles.footer}>
        <Peu />
      </footer>
    </div>
  );
};

export default App;
